import React from 'react';
import { useSelector } from 'react-redux';

// components
import { TextInput, YesNo } from '../components/inputs';
import { FormRow } from '../components/layout';
import { Collapse } from '../../../common/components';

function EmergencyContact() {
  const { hasemer } = useSelector(store => store.values);

  return (
    <div>
      <FormRow>
        <YesNo
          label="Would you like to provide an emergency contact?"
          name="hasemer"
        />
      </FormRow>
      <Collapse recalculateHeightOnChange={hasemer} isOpen={hasemer}>
        <FormRow>
          <TextInput
            label="First name"
            name="emerfname"
            cols="6"
          />
          <TextInput
            label="Last name"
            name="emerlname"
            cols="6"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="Phone number"
            name="emertel"
            cols="6"
          />
          <TextInput
            label="Relationship to you"
            name="emerrel"
            cols="6"
          />
        </FormRow>
      </Collapse>
    </div>
  );
}

export default EmergencyContact;
